export default "__VITE_ASSET__CEWh6H1T__"